module.exports = __webpack_public_path__ + "static/media/tryg.c51816af.jpg";